import React from 'react';
import '../App.css';

const Contact = () => {

    return (
        <div className='app contact-container'>
            <div className='contactname'>Hassaan Ahmed</div>
            <div className='contactemail'>byte9962@gmail.com</div>
        </div>
    );
};

export default Contact;
